<div class="flex flex-column justify-content-center align-items-center w-full md:px-7 pb-3">
    <h2 class="text-center">Interested in downgrading or deleting your account?</h2>
    <span class="text text-center">Thinking of deleting? Most users just need to downgrade. Since deletions are permanent, contact support to be sure.</span>
    <div class="w-full grid mt-4">
        <div class="col-12 md:col-6 py-2">
        <p-button
          label="Downgrade Plan"
          styleClass="learn-btn w-full"
          [outlined]="true"
          severity="info"
          (click)="clickDowngrade()"
        ></p-button>
    </div>
    <div class="col-12 md:col-6 py-2">
        <p-button
          label="Contact Support"
          styleClass="learn-btn w-full"
          severity="info"
          (onClick)="clickContactSupport()"
        ></p-button>
    </div>
        </div>
        <span class="text text-center mt-3">
          You can also email us:
          <a
            href="mailto:support@dollarflightclub.com"
            class="underline text-gray-600"
          >
            support&#64;dollarflightclub.com
          </a>
        </span>
</div>
